"use client";

import Link from "next/link";
import { Button, Col, Container, Row } from "react-bootstrap";

const TrendingArticleView = ({ article }) => {
  return (
    <Container>
      <h4 className="text-start text-primary my-5">{article?.title}</h4>

      <div dangerouslySetInnerHTML={{ __html: article?.description }} />

      {!article && (
        <Container className="text-center my-5 mh-60">
          <Row className="justify-content-center align-items-center">
            <Col md={8}>
              <h1 className="display-1">404</h1>
              <h2 className="display-4">Page Not Found</h2>
              <p className="lead">
                Sorry, the page you are looking for does not exist.
              </p>
              <Button variant="primary" as={Link} href="/articles">
                Go Back
              </Button>
            </Col>
          </Row>
        </Container>
      )}
    </Container>
  );
};

export default TrendingArticleView;
